// fiuhb_frontend/src/services/finance_services/billService.js
import { API_BASE_URL } from '../../constants/appConstants';
import { authenticatedRequest } from '../authService';

const Finance_Base_Url = `${API_BASE_URL}/finances`;

// Bill Services
export const getBills = async (page = 1, pageSize = 10, filters = {}, invitationId = null) => {
  const params = new URLSearchParams({
    page: page.toString(),
    page_size: pageSize.toString()
  });
  
  // Add optional filter parameters
  if (filters.search) {
    params.append('search', filters.search);
  }
  if (filters.status) {
    params.append('status', filters.status);
  }
  if (filters.date_range) {
    params.append('date_range', filters.date_range);
  }
  if (filters.start_date) {
    params.append('start_date', filters.start_date);
  }
  if (filters.end_date) {
    params.append('end_date', filters.end_date);
  }
  if (filters.due_date_range) {
    params.append('due_date_range', filters.due_date_range);
  }
  if (filters.due_start_date) {
    params.append('due_start_date', filters.due_start_date);
  }
  if (filters.due_end_date) {
    params.append('due_end_date', filters.due_end_date);
  }
  
  if (invitationId) {
    params.append('invitation_id', invitationId);
  }
  
  const url = `${Finance_Base_Url}/bills/?${params.toString()}`;
  try {
    const response = await authenticatedRequest(url, {
      method: 'GET',
    });
    return response;
  } catch (error) {
    console.error('Error fetching bills:', error);
    throw error;
  }
};

export const createBill = async (billData, invitationId = null) => {
  const params = new URLSearchParams();
  if (invitationId) {
    params.append('invitation_id', invitationId);
  }
  
  const url = `${Finance_Base_Url}/bills/create/?${params.toString()}`;
  console.log('Creating bill with data:', billData);
  
  try {
    const response = await authenticatedRequest(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(billData),
    });
    console.log('Create bill response:', response);
    return response;
  } catch (error) {
    console.error('Error creating bill:', error);
    throw error;
  }
};

export const getBill = async (billId, invitationId = null) => {
  const params = new URLSearchParams();
  if (invitationId) {
    params.append('invitation_id', invitationId);
  }
  
  const url = `${Finance_Base_Url}/bills/${billId}/?${params.toString()}`;
  try {
    const response = await authenticatedRequest(url, {
      method: 'GET',
    });
    return response;
  } catch (error) {
    console.error('Error fetching bill:', error);
    throw error;
  }
};

export const updateBill = async (billId, billData, invitationId = null) => {
  const params = new URLSearchParams();
  if (invitationId) {
    params.append('invitation_id', invitationId);
  }
  
  const url = `${Finance_Base_Url}/bills/${billId}/update/?${params.toString()}`;
  try {
    const response = await authenticatedRequest(url, {
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(billData),
    });
    return response;
  } catch (error) {
    console.error('Error updating bill:', error);
    throw error;
  }
};

export const deleteBill = async (billId, invitationId = null) => {
  const params = new URLSearchParams();
  if (invitationId) {
    params.append('invitation_id', invitationId);
  }
  
  const url = `${Finance_Base_Url}/bills/${billId}/delete/?${params.toString()}`;
  try {
    const response = await authenticatedRequest(url, {
      method: 'DELETE',
    });
    return response;
  } catch (error) {
    console.error('Error deleting bill:', error);
    throw error;
  }
};

